import { Grid } from '@cambridgeassessment/cambridge-ui';
import React, { memo, useMemo } from 'react';
import { COUNTRY_CODE_US } from 'src/constants';
import usePlatformTiles from 'src/hooks/usePlatformTiles';
import useAuth from '../../hooks/useAuth';
import { CambridgeProduct } from '../../types';
import Loader from '../Loader/Loader';
import Product from './Product';

interface IProducts {
  products: CambridgeProduct[];
}

const Products: React.FC = () => {
  const { user } = useAuth();
  const { products, isLoading } = usePlatformTiles();

  const filteredProducts = useMemo(() => {
    if (!user) return [];
    return products.filter((product) => {
      // If product is Report Maker and user is not from US, filter it out
      if (
        product.title === 'Report Maker' &&
        user.country !== COUNTRY_CODE_US
      ) {
        return false;
      }
      return true;
    });
  }, [products, user]);

  if (isLoading) {
    return <Loader />;
  }

  return (
    <Grid container>
      {filteredProducts.map((product, index) => (
        <Grid item key={index} xs={12} sm={6} md={4} lg={4} xl={4}>
          <Product key={product.title} {...product} />
        </Grid>
      ))}
    </Grid>
  );
};

export default memo(Products);
